// TODO: work data
// import Kapysta from '../assets/Images/Kapysta.png'

export const Work = [
    {
        id:1,
        name:"Web Studio",
        description:"A website with a responsive layout.",
        tags:["HTML","CSS"],
        img: "../WebStud.png",
        
        demo:"https://v0100k.github.io/goit-markup-hw-07/",
        github:"https://github.com/V0100K/goit-js-project"
    },
    {
        id:2,
        name:"ICE CREAM",
        description:"A website types of ice cream.",
        tags:["HTML", "SASS", "JS", "Parcel"],
        img: "../IceCream.png",

        demo:"https://v0100k.github.io/goit-html-css-project/",
        github:"https://github.com/V0100K/goit-html-css-project"

    },
    {
        id:3,
        name:"EVENT BOOSTER",
        description:"Application for selecting and booking tickets",
        tags:["REST API", "AJAX","HTML", "SASS", "JS", "Parcel"],
        img: "../Boost.png",

        demo:"https://v0100k.github.io/goit-js-project/",
        github:"https://github.com/V0100K/goit-js-project"
        
    },
    {
        id:4,
        name:"KAPUSTA",
        description:"Application for accounting expenses and income.",
        tags:["React","StyledComponents","React-router", "SASS", "Redux", "Axios"],
        img: "../Kapysta.png",
        
        demo:"https://react-project-money-book.netlify.app",
        github:"https://github.com/V0100K/goIT-react-project"
       
    },
    
  
] 